import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ErrorPage.css';

const ErrorPage = ({ errorCode = 404 }) => {
  const navigate = useNavigate();
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const newParticles = [];
    for (let i = 0; i < 18; i++) {
      const size = Math.random() * 20 + 6;
      newParticles.push({
        id: i,
        width: size,
        height: size,
        left: Math.random() * 100,
        animDuration: Math.random() * 14 + 8,
        animDelay: Math.random() * 10,
        opacity: Math.random() * 0.3 + 0.1
      });
    }
    setParticles(newParticles);
  }, []);

  const getErrorContent = (code) => {
    switch (code) {
      case 403:
        return {
          title: 'Acceso Denegado',
          message: 'No tienes los permisos necesarios para acceder a esta página o recurso.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="error-icon">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          ),
          badge: 'HTTP 403'
        };
      case 419:
        return {
          title: 'Token de Seguridad / Sesión Expirada',
          message: 'El token de tu sesión ha expirado o no es válido por inactividad. Por seguridad, regresa al inicio de sesión e inténtalo de nuevo.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 16 16" fill="currentColor" className="error-icon">
              <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 14v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.35z"/>
            </svg>
          ),
          badge: 'HTTP 419'
        };
      case 500:
        return {
          title: 'Error Interno del Servidor',
          message: 'Ha ocurrido un error inesperado en nuestro servidor. Nuestro equipo técnico ya ha sido notificado.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="error-icon">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          ),
          badge: 'HTTP 500'
        };
      case 503:
        return {
          title: 'Servicio no Disponible',
          message: 'El servicio se encuentra temporalmente inactivo debido a sobrecarga o mantenimiento del servidor.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="error-icon">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
            </svg>
          ),
          badge: 'HTTP 503'
        };
      case 404:
      default:
        return {
          title: 'Página no Encontrada',
          message: 'La página que estás buscando no existe, ha sido movida o está temporalmente fuera de servicio.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="error-icon">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          ),
          badge: 'HTTP 404'
        };
    }
  };

  const content = getErrorContent(Number(errorCode));

  return (
    <div className="error-page-container">
      <div className="particles">
        {particles.map(p => (
          <div
            key={p.id}
            className="particle"
            style={{
              width: `${p.width}px`,
              height: `${p.height}px`,
              left: `${p.left}%`,
              animationDuration: `${p.animDuration}s`,
              animationDelay: `${p.animDelay}s`,
              opacity: p.opacity
            }}
          />
        ))}
      </div>

      <main className="error-wrapper">
        <span className="http-badge">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          {' '}{content.badge}
        </span>
        <div className="error-code">{errorCode}</div>
        {content.icon}
        <div className="divider"></div>
        <h1 className="error-title">{content.title}</h1>
        <p className="error-subtitle">
          {content.message}
        </p>
        
        {errorCode === '419' || errorCode === 419 ? (
          <div className="timer-warning">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            {' '}Esta protección evita envíos de formularios no autorizados o protege tu sesión
          </div>
        ) : null}

        <div className="error-actions">
          <button className="btn-secondary" onClick={() => navigate(-1)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            {' '}Volver Atrás
          </button>
          <button className="btn-back" onClick={() => navigate('/')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            {' '}Ir al Inicio
          </button>
        </div>
      </main>

      <div className="waves-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2880 120" preserveAspectRatio="none" style={{ height: '120px', display: 'block' }}>
          <defs>
            <linearGradient id="wg1" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" style={{ stopColor: 'rgba(255,193,7,0.2)' }} />
              <stop offset="100%" style={{ stopColor: 'rgba(13,59,110,0.7)' }} />
            </linearGradient>
          </defs>
          <path className="wave1" fill="url(#wg1)" d="M0,60 C240,100 480,20 720,60 C960,100 1200,20 1440,60 C1680,100 1920,20 2160,60 C2400,100 2640,20 2880,60 L2880,120 L0,120 Z"/>
          <path className="wave2" fill="rgba(255,143,0,0.15)" d="M0,75 C300,40 600,110 900,75 C1200,40 1500,110 1800,75 C2100,40 2400,110 2880,80 L2880,120 L0,120 Z"/>
          <path className="wave3" fill="rgba(255,213,79,0.09)" d="M0,90 C360,65 720,115 1080,90 C1440,65 1800,115 2160,90 C2520,65 2760,105 2880,95 L2880,120 L0,120 Z"/>
        </svg>
      </div>
    </div>
  );
};

export default ErrorPage;
